<ng-container [formGroup]="form">
  <div class="formCountrySelector__title">
    <app-ds-typography
      [text]="label | transloco"
      [size]="fontSize.XXS"
      [color]="fontColor.Primary"
      [tag]="'h3'">
    </app-ds-typography>
  </div>
  <div class="passenger-form-inputs">
    <fieldset class="input">
      <app-dropdown-select
        [selectOptions]="countryNames"
        [fullWidth]="true"
        [title]="'BOOKING_MODULE.NATIONALITY' | transloco"
        [defaultOption]="defaultCountry"
        [value]="currentCountryValue"
        [showTitle]="false"
        [withSearchInput]="true"
        [optionIconClass]="'icon-location'"
        [icon]="iconLocation"
        [disabledOptionList]="disabledCountryOptions"
        [showError]="isFieldInvalid(selector)"
        [fullHeight]="true"
        [scrollFixedPosition]="false"
        [manipulateDOM]="false"
        [isMobile]="isMobile"
        (selected)="onCountrySelected($event)">
      </app-dropdown-select>
    </fieldset>
    <div class="formCountrySelector__error" *ngIf="isFieldInvalid(selector)">
      <app-ds-typography
        [text]="'BOOKING_MODULE.PAX.ERRORS.MANDATORY_FIELD' | transloco"
        [size]="fontSize.XXXS"
        [color]="fontColor.Warning"
        [tag]="'span'">
      </app-ds-typography>
    </div>
  </div>
</ng-container>
